(function() {
  'use strict';

  angular
    .module('iqxCore')
    .service('userRightsSvc', userRightsSvc)

  function userRightsSvc(ApplicationSvc){
    var svc = this
    svc.check = check

    ///////////

    function check(rights){
      var type = Object.prototype.toString.call(rights)
      if(type === "[object String]"){
        if(rights[0]==="!"){
          return !(ApplicationSvc.currentUser.UserRights.indexOf(rights.substring(1).toUpperCase()) > -1)
        }else{
          return ApplicationSvc.currentUser.UserRights.indexOf(rights.toUpperCase()) > -1
        }
      }else if(type === '[object Array]'){
        var arrayLength = rights.length
        for(var i = 0; i < arrayLength; i++){
          if(rights[i][0]==="!"){
            if(ApplicationSvc.currentUser.UserRights.indexOf(rights[i].substring(1).toUpperCase()) !== -1){
              return false
            }
          }else{
            if(ApplicationSvc.currentUser.UserRights.indexOf(rights[i].toUpperCase()) === -1){
              return false
            }
          }
        }
        return true
      }else{
        throw new Error('Parameter rights must be of type string or array')
      }
    }

  }

})()